import { gql } from '@apollo/client';
// Fragments
import { MediaPostFields } from './fragments';

export const CREATE_IMAGE_POST = gql`
  mutation CreateImagePost($input: CreateImagePostInput!) {
    createImagePost(input: $input) {
      ...MediaPostFields
    }
  }
  ${MediaPostFields}
`;

export const CREATE_IMAGE_PRESIGNED_URL_V2 = gql`
  mutation CreatePostImagePresignedUrlV2(
    $input: CreatePostImagePresignedUrlV2Input!
  ) {
    createPostImagePresignedUrlV2(input: $input) {
      fields
      key
      url
    }
  }
`;

export const EDIT_IMAGE_POST = gql`
  mutation EditImagePost($input: EditImagePostInput!) {
    editImagePost(input: $input) {
      ...MediaPostFields
    }
  }
  ${MediaPostFields}
`;

export const CREATE_VIDEO_POST = gql`
  mutation CreateVideoPost($input: CreateVideoPostInput!) {
    createVideoPost(input: $input) {
      ...MediaPostFields
    }
  }
  ${MediaPostFields}
`;

export const EDIT_VIDEO_POST = gql`
  mutation EditVideoPost($input: EditVideoPostInput!) {
    editVideoPost(input: $input) {
      ...MediaPostFields
    }
  }
  ${MediaPostFields}
`;

export const DELETE_MEDIA_POST = gql`
  mutation DeleteMediaPost($input: DeleteMediaPostInput!) {
    deleteMediaPost(input: $input) {
      id
    }
  }
`;

export const INIT_POST_VIDEO_MULTIPART_UPLOAD_V2 = gql`
  mutation InitPostVideoMultipartUploadV2(
    $input: InitVideoPostMultipartUploadInput!
  ) {
    initPostVideoMultipartUploadV2(input: $input) {
      fileId
      fileKey
      signedUrls {
        partNumber
        signedUrl
      }
    }
  }
`;

export const COMPLETE_POST_VIDEO_MULTIPART_UPLOAD = gql`
  mutation CompletePostVideoMultipartUpload(
    $input: CompleteMultipartUploadInput!
  ) {
    completePostVideoMultipartUpload(input: $input)
  }
`;

export const REJECT_AND_SEND_BACK_BY_STORE = gql`
  mutation RejectAndSendBackByStore(
    $input: ReviewActionVideoEditRequestInput!
  ) {
    rejectAndSendBackByStore(input: $input) {
      id
    }
  }
`;

export const ACCEPT_VIDEO_EDIT_SUBMISSIONS = gql`
  mutation AcceptVideoEditSubmissions(
    $input: AcceptVideoEditSubmissionsInput!
  ) {
    acceptVideoEditSubmissions(input: $input) {
      id
    }
  }
`;
